import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
    const token = localStorage.getItem("hfx_token");
    if (token) cfg.headers.Authorization = `Bearer ${token}`;
    // Tell the backend the public hostname the user is on. Reverse proxies
    // (Cloudflare, Emergent edge) rewrite the upstream Host header to the
    // internal cluster name, so this is the only reliable signal for the
    // backend to know whether to serve live or test mode.
    if (typeof window !== "undefined" && window.location?.hostname) {
        cfg.headers["X-Hfx-Public-Host"] = window.location.hostname;
    }
    return cfg;
});

export const dollars = (cents) => {
    if (cents == null) return "—";
    return `$${(cents / 100).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
};

export const fmtDate = (s) => {
    if (!s) return "";
    try {
        // A bare `YYYY-MM-DD` string is parsed by `new Date(...)` as UTC
        // midnight per the ECMAScript spec, then rendered in LOCAL time —
        // which makes the date appear one day earlier for any timezone west
        // of UTC (i.e. ~half the planet, all of the Americas). Appending an
        // explicit `T00:00:00` flips parsing semantics to "local midnight",
        // matching what the user typed in the date picker.
        const d = /^\d{4}-\d{2}-\d{2}$/.test(s) ? new Date(`${s}T00:00:00`) : new Date(s);
        return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
    } catch (e) { return s; }
};

// Format a "YYYY-MM" string (returned by anonymous event endpoints) as "Mar 2026".
export const fmtMonth = (ym) => {
    if (!ym || typeof ym !== "string" || ym.length < 7) return "";
    try {
        const d = new Date(`${ym}-01T00:00:00`);
        return d.toLocaleDateString(undefined, { year: "numeric", month: "short" });
    } catch (e) { return ym; }
};
